import MainImage from "../images/productimage/car (1).jpg";

import SlideImage1 from "../images/productimage/car (2).jpg";
import SlideImage2 from "../images/productimage/car (3).jpg";
import SlideImage3 from "../images/productimage/car (4).jpg";
import SlideImage4 from "../images/productimage/car (5).jpg";
import SlideImage5 from "../images/productimage/car (6).jpg";

const VehicleData = [
  {
    _id: 1,
    title: "Honda Civic",
    category: "Vehiles",
    Adtype: "sale",
    subcategory: "car",
    price: "LKR 7,500,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Colombo, Sri Lanka",
    description:
      "A well-maintained 2020 Honda Civic with only 25,000 kilometers on it. This car offers a sleek design, great fuel efficiency, and a smooth drive. Regularly serviced and in excellent condition.",
    make: "Honda",
    model: "Civic",
    year: 2020,
    mileage: "25,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Silver",
    fuelEfficiency: "15 km per liter",
    features: [
      "Backup camera",
      "Bluetooth connectivity",
      "Cruise control",
      "Air conditioning",
      "Keyless entry",
      "Alloy wheels",
      "Apple CarPlay",
      "Leather seats",
      "Sunroof",
      "Fog lights",
    ],
    contact: "Jane Silva - 077-123-4567",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
      
    ],
    MainImage: MainImage,brand:"Honda",
  },
  {
    _id: 2,
    title: " Toyota Corolla ",
    category: "Vehiles",
    Adtype: "rent",
    subcategory: "van",
    price: "LKR 6,200,000",
    negotiable: true,
    engin: "1.8L",
    fuel: "Hybrid",
    location: "Kandy, Sri Lanka",
    description:
      "This 2018 Toyota Corolla is in great condition with only 40,000 kilometers on it. Features a fuel-efficient hybrid engine and smooth handling.",
    make: "Toyota",
    model: "Corolla",
    year: 2018,
    mileage: "40,000 kilometers",
    fuelType: "Hybrid",
    transmission: "Automatic",
    condition: "Used, great",
    color: "White",
    fuelEfficiency: "18 km per liter",
    features: [
      "Automatic emergency braking",
      "Blind-spot monitoring",
      "Cruise control",
      "Power windows",
      "LED headlights",
      "Bluetooth connectivity",
      "Heated seats",
      "Push-button start",
      "Alloy wheels",
    ],
    contact: "Dinesh Perera - 077-555-8765",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage1,
  },
  {
    _id: 3,
    title: "Nissan X-Trail ",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "bus",
    price: "LKR 9,800,000",
    negotiable: false,
    engin: "2.5L",
    fuel: "Petrol",
    location: "Galle, Sri Lanka",
    description:
      "This 2019 Nissan X-Trail offers great off-road capability with its AWD system, along with a spacious interior, perfect for family trips.",
    make: "Nissan",
    model: "X-Trail",
    year: 2019,
    mileage: "35,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, very good",
    color: "Black",
    fuelEfficiency: "14 km per liter",
    features: [
      "All-wheel drive",
      "360-degree camera",
      "Parking sensors",
      "Panoramic sunroof",
      "Navigation system",
      "Dual-zone climate control",
      "Leather seats",
      "Apple CarPlay",
      "Android Auto",
      "Rear parking assist",
    ],
    contact: "Amal Fernando - 077-879-9876",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3, SlideImage4],
    MainImage: SlideImage2,
  },
  {
    _id: 4,
    title: " Mercedes-Benz",
    category: "sale",
    subcategory: "Motor-cycle",
    price: "LKR 15,500,000",
    negotiable: false,
    engin: "2.0L",
    fuel: "Diesel",
    location: "Colombo, Sri Lanka",
    description:
      "Luxury and performance come together in this 2021 Mercedes-Benz C-Class. With only 15,000 kilometers, it's practically new.",
    make: "Mercedes-Benz",
    model: "C-Class",
    year: 2021,
    mileage: "15,000 kilometers",
    fuelType: "Diesel",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Blue",
    fuelEfficiency: "20 km per liter",
    features: [
      "Leather seats",
      "Harman Kardon sound system",
      "Panoramic roof",
      "Adaptive cruise control",
      "Blind-spot monitoring",
      "Heated seats",
      "Power folding mirrors",
      "Ambient lighting",
      "Wireless charging",
      "Digital dashboard",
      "Rear-view camera",
    ],
    contact: "Priya Senanayake - 077-789-5432",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage3,
  },
  {
    _id: 5,
    title: " Audi",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "lorry",
    price: "LKR 13,200,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Negombo, Sri Lanka",
    description:
      "This 2017 Audi A4 comes with Quattro AWD, making it perfect for driving in any condition. It features premium interior details and performance.",
    make: "Audi",
    model: "A4",
    year: 2017,
    mileage: "60,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, good",
    color: "Gray",
    fuelEfficiency: "12 km per liter",
    features: [
      "Quattro all-wheel drive",
      "Sunroof",
      "Bang & Olufsen sound system",
      "Blind-spot monitoring",
      "Navigation system",
      "Heated steering wheel",
      "Leather upholstery",
      "Adaptive headlights",
      "Parking assist",
      "Power seats",
      "LED ambient lighting",
      "Head-up display",
    ],
    contact: "Ashan Dias - 077-345-6654",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3],
    MainImage: SlideImage4,
  },
  {
    _id: 6,
    title: " BMW 3 Series",
    category: "Vehiles",
    Adtype: "rent",
    subcategory: "Three-wheeler",
    price: "LKR 16,800,000",
    negotiable: false,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Matara, Sri Lanka",
    description:
      "A sporty 2020 BMW 3 Series with premium features and excellent handling. Low mileage and in near-new condition.",
    make: "BMW",
    model: "3 Series",
    year: 2020,
    mileage: "20,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "White",
    fuelEfficiency: "14 km per liter",
    features: [
      "M Sport package",
      "Heated front seats",
      "Wireless charging",
      "Adaptive cruise control",
      "Gesture control",
      "Heads-up display",
      "Rearview camera",
      "Dual-zone climate control",
      "Keyless start",
      "Lane departure warning",
    ],
    contact: "Shanuka Rajapakse - 077-987-4567",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: MainImage,
  },
  {
    _id: 7,
    title: " Hyundai Tucson ",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "Machinery",
    price: "LKR 5,800,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Diesel",
    location: "Kurunegala, Sri Lanka",
    description:
      "This 2016 Hyundai Tucson offers reliability and comfort, with enough space for family trips. Well-maintained and in good condition.",
    make: "Hyundai",
    model: "Tucson",
    year: 2016,
    mileage: "80,000 kilometers",
    fuelType: "Diesel",
    transmission: "Automatic",
    condition: "Used, good",
    color: "Silver",
    fuelEfficiency: "13 km per liter",
    features: [
      "Hill descent control",
      "Rear parking sensors",
      "Power tailgate",
      "Leather upholstery",
      "Roof rails",
      "Bluetooth connectivity",
      "Keyless entry",
      "Heated front seats",
      "Dual-zone climate control",
    ],
    contact: "Naveen Jayawardena - 077-234-6543",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3, SlideImage4],
    MainImage: SlideImage5,
  },
  {
    _id: 8,
    title: " Kia Sportage",
    category: "Vehiles",
    Adtype: "sale",
    subcategory: "Tractor",
    price: "LKR 7,300,000",
    negotiable: false,
    engin: "1.6L",
    fuel: "Petrol",
    location: "Batticaloa, Sri Lanka",
    description:
      "This 2019 Kia Sportage offers a great balance of comfort, style, and performance. It's packed with modern features and is in excellent condition.",
    make: "Kia",
    model: "Sportage",
    year: 2019,
    mileage: "30,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Red",
    fuelEfficiency: "16 km per liter",
    features: [
      "360-degree camera",
      "Lane keeping assist",
      "Adaptive cruise control",
      "Rear cross-traffic alert",
      "Wireless phone charger",
      "Heated steering wheel",
      "Ventilated front seats",
      "Power tailgate",
      "Panoramic sunroof",
      "Keyless start",
      "LED headlights",
    ],
    contact: "Kamal Wijesinghe - 077-345-7654",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3],
    MainImage: MainImage,
  },
  {
    _id: 9,
    title: "Mitsubishi Outlander",
    category: "Vehiles",
    Adtype: "rent",
    subcategory: "Rent-a-car",
    price: "LKR 5,200,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Jaffna, Sri Lanka",
    description:
      "A well-maintained 2015 Mitsubishi Outlander with plenty of space and excellent reliability. Ideal for families and long-distance trips.",
    make: "Mitsubishi",
    model: "Outlander",
    year: 2015,
    mileage: "100,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, good",
    color: "Blue",
    fuelEfficiency: "12 km per liter",
    features: [
      "7-seater",
      "All-wheel drive",
      "Roof rails",
      "Rearview camera",
      "Cruise control",
      "Parking sensors",
      "Bluetooth connectivity",
      "Power seats",
      "Fog lights",
      "Dual-zone climate control",
      "Third-row seats",
    ],
    contact: "Harsha Pathirana - 077-786-4532",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3],
    MainImage: MainImage,
  },
  {
    _id: 10,
    title: "Tesla Model 3",
    category: "vehiles",
    Adtype: "sale",
    subcategory: "Motor-Accessory",
    price: "LKR 25,000,000",
    negotiable: false,
    engin: "Electric",
    fuel: "Electric",
    location: "Colombo, Sri Lanka",
    description:
      "A brand new 2022 Tesla Model 3 with top-notch performance and zero emissions. Full-electric driving and cutting-edge technology.",
    make: "Tesla",
    model: "Model 3",
    year: 2022,
    mileage: "5,000 kilometers",
    fuelType: "Electric",
    transmission: "Automatic",
    condition: "New",
    color: "White",
    fuelEfficiency: "6 km per kWh",
    features: [
      "Autopilot",
      "Full self-driving capability",
      "Glass roof",
      "15-inch touchscreen",
      "Over-the-air updates",
      "Wireless charging",
      "Premium sound system",
      "Heated front and rear seats",
      "Navigation system",
      "Sentry Mode",
      "360-degree camera",
      "Lane departure warning",
    ],
    contact: "Manoj Perera - 077-986-3452",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3, SlideImage4],
    MainImage: MainImage,
  },
  {
    _id: 11,
    title: "Tesla Model",
    category: "vehiles",
    Adtype: "wanted",
    subcategory: "Service",
    price: "LKR 25,000,000",
    negotiable: false,
    engin: "Electric",
    fuel: "Electric",
    location: "Colombo, Sri Lanka",
    description:
      "A brand new 2022 Tesla Model 3 with top-notch performance and zero emissions. Full-electric driving and cutting-edge technology.",
    make: "Tesla",
    model: "Model 3",
    year: 2022,
    mileage: "5,000 kilometers",
    fuelType: "Electric",
    transmission: "Automatic",
    condition: "New",
    color: "White",
    fuelEfficiency: "6 km per kWh",
    features: [
      "Autopilot",
      "Full self-driving capability",
      "Glass roof",
      "15-inch touchscreen",
      "Over-the-air updates",
      "Wireless charging",
      "Premium sound system",
      "Heated front and rear seats",
      "Navigation system",
      "Sentry Mode",
      "360-degree camera",
      "Lane departure warning",
    ],
    contact: "Manoj Perera - 077-986-3452",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3, SlideImage4],
    MainImage: MainImage,
  },
  {
    _id: 12,
    title: "Honda Civic",
    category: "Vehiles",
    Adtype: "sale",
    subcategory: "car",
    price: "LKR 7,500,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Colombo, Sri Lanka",
    description:
      "A well-maintained 2020 Honda Civic with only 25,000 kilometers on it. This car offers a sleek design, great fuel efficiency, and a smooth drive. Regularly serviced and in excellent condition.",
    make: "Honda",
    model: "Civic",
    year: 2020,
    mileage: "25,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Silver",
    fuelEfficiency: "15 km per liter",
    features: [
      "Backup camera",
      "Bluetooth connectivity",
      "Cruise control",
      "Air conditioning",
      "Keyless entry",
      "Alloy wheels",
      "Apple CarPlay",
      "Leather seats",
      "Sunroof",
      "Fog lights",
    ],
    contact: "Jane Silva - 077-123-4567",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
      
    ],
    MainImage: MainImage,
  },
  {
    _id: 22,
    title: " Toyota Corolla ",
    category: "Vehiles",
    Adtype: "rent",
    subcategory: "van",
    price: "LKR 6,200,000",
    negotiable: true,
    engin: "1.8L",
    fuel: "Hybrid",
    location: "Kandy, Sri Lanka",
    description:
      "This 2018 Toyota Corolla is in great condition with only 40,000 kilometers on it. Features a fuel-efficient hybrid engine and smooth handling.",
    make: "Toyota",
    model: "Corolla",
    year: 2018,
    mileage: "40,000 kilometers",
    fuelType: "Hybrid",
    transmission: "Automatic",
    condition: "Used, great",
    color: "White",
    fuelEfficiency: "18 km per liter",
    features: [
      "Automatic emergency braking",
      "Blind-spot monitoring",
      "Cruise control",
      "Power windows",
      "LED headlights",
      "Bluetooth connectivity",
      "Heated seats",
      "Push-button start",
      "Alloy wheels",
    ],
    contact: "Dinesh Perera - 077-555-8765",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage1,
  },
  {
    _id: 23,
    title: "Nissan X-Trail ",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "bus",
    price: "LKR 9,800,000",
    negotiable: false,
    engin: "2.5L",
    fuel: "Petrol",
    location: "Galle, Sri Lanka",
    description:
      "This 2019 Nissan X-Trail offers great off-road capability with its AWD system, along with a spacious interior, perfect for family trips.",
    make: "Nissan",
    model: "X-Trail",
    year: 2019,
    mileage: "35,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, very good",
    color: "Black",
    fuelEfficiency: "14 km per liter",
    features: [
      "All-wheel drive",
      "360-degree camera",
      "Parking sensors",
      "Panoramic sunroof",
      "Navigation system",
      "Dual-zone climate control",
      "Leather seats",
      "Apple CarPlay",
      "Android Auto",
      "Rear parking assist",
    ],
    contact: "Amal Fernando - 077-879-9876",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3, SlideImage4],
    MainImage: SlideImage2,
  },
  {
    _id: 24,
    title: " Mercedes-Benz",
    category: "sale",
    subcategory: "Motor-cycle",
    price: "LKR 15,500,000",
    negotiable: false,
    engin: "2.0L",
    fuel: "Diesel",
    location: "Colombo, Sri Lanka",
    description:
      "Luxury and performance come together in this 2021 Mercedes-Benz C-Class. With only 15,000 kilometers, it's practically new.",
    make: "Mercedes-Benz",
    model: "C-Class",
    year: 2021,
    mileage: "15,000 kilometers",
    fuelType: "Diesel",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Blue",
    fuelEfficiency: "20 km per liter",
    features: [
      "Leather seats",
      "Harman Kardon sound system",
      "Panoramic roof",
      "Adaptive cruise control",
      "Blind-spot monitoring",
      "Heated seats",
      "Power folding mirrors",
      "Ambient lighting",
      "Wireless charging",
      "Digital dashboard",
      "Rear-view camera",
    ],
    contact: "Priya Senanayake - 077-789-5432",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage3,
  },
  {
    _id: 25,
    title: " Audi",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "lorry",
    price: "LKR 13,200,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Negombo, Sri Lanka",
    description:
      "This 2017 Audi A4 comes with Quattro AWD, making it perfect for driving in any condition. It features premium interior details and performance.",
    make: "Audi",
    model: "A4",
    year: 2017,
    mileage: "60,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, good",
    color: "Gray",
    fuelEfficiency: "12 km per liter",
    features: [
      "Quattro all-wheel drive",
      "Sunroof",
      "Bang & Olufsen sound system",
      "Blind-spot monitoring",
      "Navigation system",
      "Heated steering wheel",
      "Leather upholstery",
      "Adaptive headlights",
      "Parking assist",
      "Power seats",
      "LED ambient lighting",
      "Head-up display",
    ],
    contact: "Ashan Dias - 077-345-6654",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3],
    MainImage: SlideImage4,
  },
  {
    _id: 17,
    title: "Honda Civic",
    category: "Vehiles",
    Adtype: "sale",
    subcategory: "car",
    price: "LKR 7,500,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Colombo, Sri Lanka",
    description:
      "A well-maintained 2020 Honda Civic with only 25,000 kilometers on it. This car offers a sleek design, great fuel efficiency, and a smooth drive. Regularly serviced and in excellent condition.",
    make: "Honda",
    model: "Civic",
    year: 2020,
    mileage: "25,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Silver",
    fuelEfficiency: "15 km per liter",
    features: [
      "Backup camera",
      "Bluetooth connectivity",
      "Cruise control",
      "Air conditioning",
      "Keyless entry",
      "Alloy wheels",
      "Apple CarPlay",
      "Leather seats",
      "Sunroof",
      "Fog lights",
    ],
    contact: "Jane Silva - 077-123-4567",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
      
    ],
    MainImage: MainImage,
  },
  {
    _id: 299,
    title: " Toyota Corolla ",
    category: "Vehiles",
    Adtype: "rent",
    subcategory: "van",
    price: "LKR 6,200,000",
    negotiable: true,
    engin: "1.8L",
    fuel: "Hybrid",
    location: "Kandy, Sri Lanka",
    description:
      "This 2018 Toyota Corolla is in great condition with only 40,000 kilometers on it. Features a fuel-efficient hybrid engine and smooth handling.",
    make: "Toyota",
    model: "Corolla",
    year: 2018,
    mileage: "40,000 kilometers",
    fuelType: "Hybrid",
    transmission: "Automatic",
    condition: "Used, great",
    color: "White",
    fuelEfficiency: "18 km per liter",
    features: [
      "Automatic emergency braking",
      "Blind-spot monitoring",
      "Cruise control",
      "Power windows",
      "LED headlights",
      "Bluetooth connectivity",
      "Heated seats",
      "Push-button start",
      "Alloy wheels",
    ],
    contact: "Dinesh Perera - 077-555-8765",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage1,
  },
  {
    _id: 93,
    title: "Nissan X-Trail ",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "bus",
    price: "LKR 9,800,000",
    negotiable: false,
    engin: "2.5L",
    fuel: "Petrol",
    location: "Galle, Sri Lanka",
    description:
      "This 2019 Nissan X-Trail offers great off-road capability with its AWD system, along with a spacious interior, perfect for family trips.",
    make: "Nissan",
    model: "X-Trail",
    year: 2019,
    mileage: "35,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, very good",
    color: "Black",
    fuelEfficiency: "14 km per liter",
    features: [
      "All-wheel drive",
      "360-degree camera",
      "Parking sensors",
      "Panoramic sunroof",
      "Navigation system",
      "Dual-zone climate control",
      "Leather seats",
      "Apple CarPlay",
      "Android Auto",
      "Rear parking assist",
    ],
    contact: "Amal Fernando - 077-879-9876",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3, SlideImage4],
    MainImage: SlideImage2,
  },
  {
    _id: 984,
    title: " Mercedes-Benz",
    category: "sale",
    subcategory: "Motor-cycle",
    price: "LKR 15,500,000",
    negotiable: false,
    engin: "2.0L",
    fuel: "Diesel",
    location: "Colombo, Sri Lanka",
    description:
      "Luxury and performance come together in this 2021 Mercedes-Benz C-Class. With only 15,000 kilometers, it's practically new.",
    make: "Mercedes-Benz",
    model: "C-Class",
    year: 2021,
    mileage: "15,000 kilometers",
    fuelType: "Diesel",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Blue",
    fuelEfficiency: "20 km per liter",
    features: [
      "Leather seats",
      "Harman Kardon sound system",
      "Panoramic roof",
      "Adaptive cruise control",
      "Blind-spot monitoring",
      "Heated seats",
      "Power folding mirrors",
      "Ambient lighting",
      "Wireless charging",
      "Digital dashboard",
      "Rear-view camera",
    ],
    contact: "Priya Senanayake - 077-789-5432",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage3,
  },
  {
    _id: 34545559,
    title: " Audi",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "lorry",
    price: "LKR 13,200,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Negombo, Sri Lanka",
    description:
      "This 2017 Audi A4 comes with Quattro AWD, making it perfect for driving in any condition. It features premium interior details and performance.",
    make: "Audi",
    model: "A4",
    year: 2017,
    mileage: "60,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, good",
    color: "Gray",
    fuelEfficiency: "12 km per liter",
    features: [
      "Quattro all-wheel drive",
      "Sunroof",
      "Bang & Olufsen sound system",
      "Blind-spot monitoring",
      "Navigation system",
      "Heated steering wheel",
      "Leather upholstery",
      "Adaptive headlights",
      "Parking assist",
      "Power seats",
      "LED ambient lighting",
      "Head-up display",
    ],
    contact: "Ashan Dias - 077-345-6654",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3],
    MainImage: SlideImage4,
  },
  {
    _id: 3454351,
    title: "Honda Civic",
    category: "Vehiles",
    Adtype: "sale",
    subcategory: "car",
    price: "LKR 7,500,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Colombo, Sri Lanka",
    description:
      "A well-maintained 2020 Honda Civic with only 25,000 kilometers on it. This car offers a sleek design, great fuel efficiency, and a smooth drive. Regularly serviced and in excellent condition.",
    make: "Honda",
    model: "Civic",
    year: 2020,
    mileage: "25,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Silver",
    fuelEfficiency: "15 km per liter",
    features: [
      "Backup camera",
      "Bluetooth connectivity",
      "Cruise control",
      "Air conditioning",
      "Keyless entry",
      "Alloy wheels",
      "Apple CarPlay",
      "Leather seats",
      "Sunroof",
      "Fog lights",
    ],
    contact: "Jane Silva - 077-123-4567",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
      
    ],
    MainImage: MainImage,
  },
  {
    _id: 543452,
    title: " Toyota Corolla ",
    category: "Vehiles",
    Adtype: "rent",
    subcategory: "van",
    price: "LKR 6,200,000",
    negotiable: true,
    engin: "1.8L",
    fuel: "Hybrid",
    location: "Kandy, Sri Lanka",
    description:
      "This 2018 Toyota Corolla is in great condition with only 40,000 kilometers on it. Features a fuel-efficient hybrid engine and smooth handling.",
    make: "Toyota",
    model: "Corolla",
    year: 2018,
    mileage: "40,000 kilometers",
    fuelType: "Hybrid",
    transmission: "Automatic",
    condition: "Used, great",
    color: "White",
    fuelEfficiency: "18 km per liter",
    features: [
      "Automatic emergency braking",
      "Blind-spot monitoring",
      "Cruise control",
      "Power windows",
      "LED headlights",
      "Bluetooth connectivity",
      "Heated seats",
      "Push-button start",
      "Alloy wheels",
    ],
    contact: "Dinesh Perera - 077-555-8765",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage1,
  },
  {
    _id: 34354,
    title: "Nissan X-Trail ",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "bus",
    price: "LKR 9,800,000",
    negotiable: false,
    engin: "2.5L",
    fuel: "Petrol",
    location: "Galle, Sri Lanka",
    description:
      "This 2019 Nissan X-Trail offers great off-road capability with its AWD system, along with a spacious interior, perfect for family trips.",
    make: "Nissan",
    model: "X-Trail",
    year: 2019,
    mileage: "35,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, very good",
    color: "Black",
    fuelEfficiency: "14 km per liter",
    features: [
      "All-wheel drive",
      "360-degree camera",
      "Parking sensors",
      "Panoramic sunroof",
      "Navigation system",
      "Dual-zone climate control",
      "Leather seats",
      "Apple CarPlay",
      "Android Auto",
      "Rear parking assist",
    ],
    contact: "Amal Fernando - 077-879-9876",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3, SlideImage4],
    MainImage: SlideImage2,
  },
  {
    _id: 4354,
    title: " Mercedes-Benz",
    category: "sale",
    subcategory: "Motor-cycle",
    price: "LKR 15,500,000",
    negotiable: false,
    engin: "2.0L",
    fuel: "Diesel",
    location: "Colombo, Sri Lanka",
    description:
      "Luxury and performance come together in this 2021 Mercedes-Benz C-Class. With only 15,000 kilometers, it's practically new.",
    make: "Mercedes-Benz",
    model: "C-Class",
    year: 2021,
    mileage: "15,000 kilometers",
    fuelType: "Diesel",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Blue",
    fuelEfficiency: "20 km per liter",
    features: [
      "Leather seats",
      "Harman Kardon sound system",
      "Panoramic roof",
      "Adaptive cruise control",
      "Blind-spot monitoring",
      "Heated seats",
      "Power folding mirrors",
      "Ambient lighting",
      "Wireless charging",
      "Digital dashboard",
      "Rear-view camera",
    ],
    contact: "Priya Senanayake - 077-789-5432",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage3,
  },
  {
    _id: 84785,
    title: " Audi",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "lorry",
    price: "LKR 13,200,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Negombo, Sri Lanka",
    description:
      "This 2017 Audi A4 comes with Quattro AWD, making it perfect for driving in any condition. It features premium interior details and performance.",
    make: "Audi",
    model: "A4",
    year: 2017,
    mileage: "60,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, good",
    color: "Gray",
    fuelEfficiency: "12 km per liter",
    features: [
      "Quattro all-wheel drive",
      "Sunroof",
      "Bang & Olufsen sound system",
      "Blind-spot monitoring",
      "Navigation system",
      "Heated steering wheel",
      "Leather upholstery",
      "Adaptive headlights",
      "Parking assist",
      "Power seats",
      "LED ambient lighting",
      "Head-up display",
    ],
    contact: "Ashan Dias - 077-345-6654",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3],
    MainImage: SlideImage4,
  },
  {
    _id: 1431231,
    title: "Honda Civic",
    category: "Vehiles",
    Adtype: "sale",
    subcategory: "car",
    price: "LKR 7,500,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Colombo, Sri Lanka",
    description:
      "A well-maintained 2020 Honda Civic with only 25,000 kilometers on it. This car offers a sleek design, great fuel efficiency, and a smooth drive. Regularly serviced and in excellent condition.",
    make: "Honda",
    model: "Civic",
    year: 2020,
    mileage: "25,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Silver",
    fuelEfficiency: "15 km per liter",
    features: [
      "Backup camera",
      "Bluetooth connectivity",
      "Cruise control",
      "Air conditioning",
      "Keyless entry",
      "Alloy wheels",
      "Apple CarPlay",
      "Leather seats",
      "Sunroof",
      "Fog lights",
    ],
    contact: "Jane Silva - 077-123-4567",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
      
    ],
    MainImage: MainImage,
  },
  {
    _id: 5465462,
    title: " Toyota Corolla ",
    category: "Vehiles",
    Adtype: "rent",
    subcategory: "van",
    price: "LKR 6,200,000",
    negotiable: true,
    engin: "1.8L",
    fuel: "Hybrid",
    location: "Kandy, Sri Lanka",
    description:
      "This 2018 Toyota Corolla is in great condition with only 40,000 kilometers on it. Features a fuel-efficient hybrid engine and smooth handling.",
    make: "Toyota",
    model: "Corolla",
    year: 2018,
    mileage: "40,000 kilometers",
    fuelType: "Hybrid",
    transmission: "Automatic",
    condition: "Used, great",
    color: "White",
    fuelEfficiency: "18 km per liter",
    features: [
      "Automatic emergency braking",
      "Blind-spot monitoring",
      "Cruise control",
      "Power windows",
      "LED headlights",
      "Bluetooth connectivity",
      "Heated seats",
      "Push-button start",
      "Alloy wheels",
    ],
    contact: "Dinesh Perera - 077-555-8765",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage1,
  },
  {
    _id: 2343,
    title: "Nissan X-Trail ",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "bus",
    price: "LKR 9,800,000",
    negotiable: false,
    engin: "2.5L",
    fuel: "Petrol",
    location: "Galle, Sri Lanka",
    description:
      "This 2019 Nissan X-Trail offers great off-road capability with its AWD system, along with a spacious interior, perfect for family trips.",
    make: "Nissan",
    model: "X-Trail",
    year: 2019,
    mileage: "35,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, very good",
    color: "Black",
    fuelEfficiency: "14 km per liter",
    features: [
      "All-wheel drive",
      "360-degree camera",
      "Parking sensors",
      "Panoramic sunroof",
      "Navigation system",
      "Dual-zone climate control",
      "Leather seats",
      "Apple CarPlay",
      "Android Auto",
      "Rear parking assist",
    ],
    contact: "Amal Fernando - 077-879-9876",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3, SlideImage4],
    MainImage: SlideImage2,
  },
  {
    _id: 3234,
    title: " Mercedes-Benz",
    category: "sale",
    subcategory: "Motor-cycle",
    price: "LKR 15,500,000",
    negotiable: false,
    engin: "2.0L",
    fuel: "Diesel",
    location: "Colombo, Sri Lanka",
    description:
      "Luxury and performance come together in this 2021 Mercedes-Benz C-Class. With only 15,000 kilometers, it's practically new.",
    make: "Mercedes-Benz",
    model: "C-Class",
    year: 2021,
    mileage: "15,000 kilometers",
    fuelType: "Diesel",
    transmission: "Automatic",
    condition: "Used, excellent",
    color: "Blue",
    fuelEfficiency: "20 km per liter",
    features: [
      "Leather seats",
      "Harman Kardon sound system",
      "Panoramic roof",
      "Adaptive cruise control",
      "Blind-spot monitoring",
      "Heated seats",
      "Power folding mirrors",
      "Ambient lighting",
      "Wireless charging",
      "Digital dashboard",
      "Rear-view camera",
    ],
    contact: "Priya Senanayake - 077-789-5432",
    SlideImages: [
      SlideImage1,
      SlideImage2,
      SlideImage3,
      SlideImage4,
      SlideImage5,
    ],
    MainImage: SlideImage3,
  },
  {
    _id: 557,
    title: " Audi",
    category: "Vehiles",
    Adtype: "wanted",
    subcategory: "lorry",
    price: "LKR 13,200,000",
    negotiable: true,
    engin: "2.0L",
    fuel: "Petrol",
    location: "Negombo, Sri Lanka",
    description:
      "This 2017 Audi A4 comes with Quattro AWD, making it perfect for driving in any condition. It features premium interior details and performance.",
    make: "Audi",
    model: "A4",
    year: 2017,
    mileage: "60,000 kilometers",
    fuelType: "Petrol",
    transmission: "Automatic",
    condition: "Used, good",
    color: "Gray",
    fuelEfficiency: "12 km per liter",
    features: [
      "Quattro all-wheel drive",
      "Sunroof",
      "Bang & Olufsen sound system",
      "Blind-spot monitoring",
      "Navigation system",
      "Heated steering wheel",
      "Leather upholstery",
      "Adaptive headlights",
      "Parking assist",
      "Power seats",
      "LED ambient lighting",
      "Head-up display",
    ],
    contact: "Ashan Dias - 077-345-6654",
    SlideImages: [SlideImage1, SlideImage2, SlideImage3],
    MainImage: SlideImage4,
  },
  
];
export default VehicleData
